import { render, staticRenderFns } from "./NormalSearchNav184.vue?vue&type=template&id=5fc4f4a2&scoped=true"
import script from "./NormalSearchNav184.vue?vue&type=script&lang=js"
export * from "./NormalSearchNav184.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fc4f4a2",
  null
  
)

export default component.exports